import api from '../api';

export const POLL_MAKE_INVALIDATE = 'POLL_MAKE_INVALIDATE';

export const POLL_DELETE_REQUEST = 'POLL_DELETE_REQUEST';
export const POLL_DELETE_SUCCESS = 'POLL_DELETE_SUCCESS';
export const POLL_DELETE_FAILURE = 'POLL_DELETE_FAILURE';

export const POLL_PUBLISH_REQUEST = 'POLL_PUBLISH_REQUEST';
export const POLL_PUBLISH_SUCCESS = 'POLL_PUBLISH_SUCCESS';
export const POLL_PUBLISH_FAILURE = 'POLL_PUBLISH_FAILURE';

export const POLL_PAUSE_REQUEST = 'POLL_PAUSE_REQUEST';
export const POLL_PAUSE_SUCCESS = 'POLL_PAUSE_SUCCESS';
export const POLL_PAUSE_FAILURE = 'POLL_PAUSE_FAILURE';

export const POLL_REQUEST = 'POLL_REQUEST';
export const POLL_SUCCESS = 'POLL_SUCCESS';
export const POLL_FAILURE = 'POLL_FAILURE';

export const VOTE_REQUEST = 'VOTE_REQUEST';
export const VOTE_SUCCESS = 'VOTE_SUCCESS';
export const VOTE_FAILURE = 'VOTE_FAILURE';

export const EDIT_POLL_REQUEST = 'EDIT_POLL_REQUEST';
export const EDIT_POLL_REQUEST_SUCCESS = 'EDIT_POLL_REQUEST_SUCCESS';
export const EDIT_POLL_REQUEST_FAILURE = 'EDIT_POLL_REQUEST_FAILURE';
export const EDIT_POLL_CANCEL = 'EDIT_POLL_CANCEL';
export const EDIT_POLL_CANCEL_SUCCESS = 'EDIT_POLL_CANCEL_SUCCESS';
export const EDIT_POLL_CANCEL_FAILURE = 'EDIT_POLL_CANCEL_FAILURE';
export const UPDATE_POLL_REQUEST = 'UPDATE_POLL_REQUEST';
export const UPDATE_POLL_SUCCESS = 'UPDATE_POLL_SUCCESS';
export const UPDATE_POLL_FAILURE = 'UPDATE_POLL_FAILURE';

export const pollMakeInvalidate = () => ({
  type: POLL_MAKE_INVALIDATE,
});

// Удаление опроса
export const pollDeleteRequest = () => ({
  type: POLL_DELETE_REQUEST,
});

export const pollDeleteSuccess = id => ({
  type: POLL_DELETE_SUCCESS,
  payload: id,
});

export const pollDeleteFailure = errString => ({
  type: POLL_DELETE_FAILURE,
  payload: { err: errString },
});

// Публикация опроса
export const pollPublishRequest = () => ({
  type: POLL_PUBLISH_REQUEST,
});

export const pollPublishSuccess = data => ({
  type: POLL_PUBLISH_SUCCESS,
  payload: data,
});

export const pollPublishFailure = errString => ({
  type: POLL_PUBLISH_FAILURE,
  payload: { err: errString },
});

// Приостановка опроса
export const pollPauseRequest = () => ({
  type: POLL_PAUSE_REQUEST,
});

export const pollPauseSuccess = data => ({
  type: POLL_PAUSE_SUCCESS,
  payload: data,
});

export const pollPauseFailure = errString => ({
  type: POLL_PAUSE_FAILURE,
  payload: { err: errString },
});

// Запрос подробных данных опроса
export const pollRequest = () => ({
  type: POLL_REQUEST,
});

export const pollSuccess = data => ({
  type: POLL_SUCCESS,
  payload: data,
});

export const pollFailure = errString => ({
  type: POLL_FAILURE,
  payload: { err: errString },
});


// Запрос голосования
export const voteRequest = () => ({
  type: VOTE_REQUEST,
});

export const voteSuccess = data => ({
  type: VOTE_SUCCESS,
  payload: data,
});

export const voteFailure = errString => ({
  type: VOTE_FAILURE,
  payload: { err: errString },
});


// Запрос редактирования
export const editPollRequest = () => ({
  type: EDIT_POLL_REQUEST,
});

export const editPollRequestSuccess = data => ({
  type: EDIT_POLL_REQUEST_SUCCESS,
  payload: data,
});

export const editPollRequestFailure = errString => ({
  type: EDIT_POLL_REQUEST_FAILURE,
  payload: { err: errString },
});


// отмена редактирования
export const editPollCancel = () => ({
  type: EDIT_POLL_CANCEL,
});

export const editPollCancelSuccess = data => ({
  type: EDIT_POLL_CANCEL_SUCCESS,
  payload: data,
});

export const editPollCancelFailure = errString => ({
  type: EDIT_POLL_CANCEL_FAILURE,
  payload: { err: errString },
});


// обновление формы / редактирование
export const updatePollRequest = () => ({
  type: UPDATE_POLL_REQUEST,
});

export const updatePollSuccess = data => ({
  type: UPDATE_POLL_SUCCESS,
  payload: data,
});

export const updatePollFailure = errString => ({
  type: UPDATE_POLL_FAILURE,
  payload: { err: errString },
});

/**
* Преобразование данных из api в state для для подробных данных по голосованию
*/
export const api2statePollInfo = (apiData) => {
  const apiPoll = apiData.data.poll;
  const poll = {};

  poll.id = apiPoll.id;
  poll.title = apiPoll.title;
  poll.descr = apiPoll.description;
  poll.status = apiPoll.status;
  poll.createdAt = apiPoll.created_at;
  poll.endsAt = apiPoll.ends_at;
  poll.updatedAt = apiPoll.updated_at;
  poll.isOwner = apiPoll.owner;
  poll.creator = apiPoll.creator ? apiPoll.creator.name : '';
  poll.updater = apiPoll.updater ? apiPoll.updater.name : '';

  poll.votes = apiPoll.votes;
  poll.votesLeft = apiPoll.votes_left;
  poll.votersAmount = apiPoll.voters_amount;
  poll.choices = apiPoll.choices;

  poll.cost = apiPoll.cost;
  return poll;
};


/**
* Удаление опроса (PUT /polls/publish)
*/
export const deletePoll = (id, cb) => (
  async (dispatch) => {
    dispatch(pollDeleteRequest());
    try {
      await api('cabinet/polls/delete', 'delete', {
        data: { poll_id: id },
      });
      dispatch(pollDeleteSuccess(id));
      if (typeof cb === 'function') {
        cb();
      }
    } catch (error) {
      dispatch(pollDeleteFailure('Не удалось удалить опрос'));
    }
  }
);


/**
* Публикация опроса (PUT /polls/publish)
*/
export const publishPoll = id => (
  async (dispatch) => {
    dispatch(pollPublishRequest());
    try {
      const response = await api('cabinet/polls/publish', 'put', {
        data: { poll_id: id },
      });
      dispatch(pollPublishSuccess(api2statePollInfo(response)));
    } catch (error) {
      dispatch(pollPublishFailure('Не удалось опубликовать опрос'));
    }
  }
);

/**
* Приостановка опроса (PUT /polls/pause)
*/
export const pausePoll = id => (
  async (dispatch) => {
    dispatch(pollPauseRequest());
    try {
      const response = await api('cabinet/polls/pause', 'put', {
        data: { poll_id: id },
      });
      dispatch(pollPauseSuccess(api2statePollInfo(response)));
    } catch (error) {
      dispatch(pollPauseFailure('Не удалось приостановить/возобновить опрос'));
    }
  }
);


/**
* Получение данных голосования (GET /polls/info)
*/
export const fetchPoll = id => (
  async (dispatch) => {
    dispatch(pollRequest());
    try {
      const response = await api('cabinet/polls/info', 'get', {
        params: { id },
      });
      dispatch(pollSuccess(api2statePollInfo(response)));
    } catch (error) {
      dispatch(pollFailure('Не удалось получить данные голосования'));
    }
  }
);


/**
* Голосование (POST /polls/vote)
*/
export const vote = (pollId, choiceId) => (
  async (dispatch) => {
    dispatch(voteRequest());
    try {
      const response = await api('cabinet/polls/vote', 'post', { data: {
        poll_id: parseInt(pollId, 10),
        choice_id: parseInt(choiceId, 10),
      } });
      dispatch(voteSuccess(api2statePollInfo(response)));
    } catch (error) {
      dispatch(voteFailure('Не удалось отправить ваш голос'));
    }
  }
);


/**
* Далее запросы: блокировка для редакитрования и обновление (редактирование) опроса
*/

/**
* Запрос на редактирование (опрос блокируется) (GET /polls/edit)
*/
export const beginEditPoll = id => (
  async (dispatch) => {
    dispatch(editPollRequest());
    try {
      const response = await api('cabinet/polls/edit', 'put', {
        params: { poll_id: id },
      });
      dispatch(editPollRequestSuccess(api2statePollInfo(response)));
    } catch (error) {
      dispatch(editPollRequestFailure('Не удалось заблокировать и получить данные опроса'));
    }
  }
);

/**
* Обновление голосования (POST /polls/update)
*/
export const updatePoll = (pollData, cb) => (
  async (dispatch) => {
    dispatch(updatePollRequest(pollData));
    try {
      const response = await api('cabinet/polls/update', 'put', { data: pollData });
      if (response.data.result === 'success') {
        dispatch(updatePollSuccess(api2statePollInfo(response)));
        if (typeof cb === 'function') {
          cb();
        }
      }
    } catch (error) {
      dispatch(updatePollFailure('Не удалось обновить данные голосования'));
    }
  }
);

/**
* Отмена редактирования голосования (POST /polls/edit/cancel), возвращение статуса
*/
export const stopEditPoll = id => (
  async (dispatch) => {
    dispatch(editPollCancel(id));
    try {
      const response = await api('cabinet/polls/edit/cancel', 'put', {
        params: { poll_id: id },
      });
      dispatch(editPollCancelSuccess(api2statePollInfo(response)));
    } catch (error) {
      dispatch(editPollCancelFailure('Не удалось послать запрос об отмене редактирования голосования'));
    }
  }
);
